const note = {
	name: 'Note | Notes',
	icon: '',
	fields: {
		priority: 'Priority',
		subject: 'Subject',
		notes_types: {
			name: 'Note type',
		},
		date_start: 'Start date',
		date_end: 'End date',
		valid_until: 'Visible until',
	},
}

export default note
